'use client';
import { cn } from '@/lib/utils';
import { motion, useAnimation, Variants } from 'framer-motion';
import React, { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

export interface SlotSymbolProps {
  symbol: number;
}

interface Props {
  num: number;
  children: (props: SlotSymbolProps) => React.ReactNode;
  height: number /* px */;
  width: number /* px */;
}

const SlotReel = ({ num, height, width, children }: Props) => {
  const controls = useAnimation();
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.5 });

  useEffect(() => {
    if (inView) controls.start('spin').then();
  }, [inView, controls]);

  const sequence = Array.from({ length: num + 1 }, (_, i) => i);
  const spinDistance = -1 * height * num;

  const variants: Variants = {
    idle: { y: 0 },
    spin: {
      // y: spinDistance,
      y: [0, spinDistance * 0.33, spinDistance * 0.66, spinDistance],
      transition: {
        duration: 1.2,
        ease: 'easeOut',
        times: [0, 0.33, 0.66, 1], // 각 중단점에서의 타이밍
      },
    },
  };

  return (
    <div
      ref={ref}
      className={cn(
        `overflow-hidden rounded-md`,
        `h-[${height}px] w-[${width}px]`,
      )}
    >
      <motion.div
        initial="idle"
        animate={controls}
        variants={variants}
        className="flex flex-col"
      >
        {sequence.map((sym, i) => (
          <div
            key={i}
            // className={cn(`h-[${height}px] w-[${width}px]`)}
            style={{ height: `${height}px`, width: `${width}px` }}
          >
            {children({ symbol: sym })}
          </div>
        ))}
      </motion.div>
    </div>
  );
};

export default SlotReel;
